/**
 * Prepare vehicle stock data from vehicle specs array
 * @param {Array} vehicleSpecs - Array of vehicle spec objects { id, key, value, type }
 * @returns {Object} Prepared vehicle stock data
 */
export const prepareVehicleStockFromSpecs = (vehicleSpecs = []) => {
  const data = {}

  vehicleSpecs.forEach(spec => {
    const key = spec.key.toLowerCase().replace(/\s+/g, "_")
    const value = spec.value ?? null

    switch (key) {
      case "descriptions":
        data.short_descriptions = value
        break

      case "chassis_no":
        data.full_chassis = value
        break

      case "engine_no":
        data.full_engine = value
        break

      case "model":
        data.vs_year_id = value // Replace with actual foreign key mapping if needed
        break

      case "color":
        data.vs_ex_color_id = value // Replace with color foreign key mapping
        break

      case "cc":
        data.vs_engine_cc_id = value // Replace with engine CC foreign key mapping
        break

      case "fuel_type":
        data.vs_fuel_type_id = value // Replace with fuel type foreign key mapping
        break

      default:
        // Ignore other fields
        break
    }
  })
  return data
}
